module.exports = __webpack_public_path__ + "img/medical-card-bg-2.be861bea.png";